import { render, staticRenderFns } from "./ContentItemEditor.vue?vue&type=template&id=9cd197ba&"
import script from "./ContentItemEditor.vue?vue&type=script&lang=js&"
export * from "./ContentItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentItemEditor.vue"
export default component.exports